export { CardsModule } from './cards.module';
export { CardRevealComponent } from './card-reveal.component';
export { CardRotatingComponent } from './card-rotating.component';



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/cards/index.ts